import { render, staticRenderFns } from "./card-list.vue?vue&type=template&id=fdee9918&scoped=true&"
import script from "./card-list.vue?vue&type=script&lang=js&"
export * from "./card-list.vue?vue&type=script&lang=js&"
import style0 from "./card-list.vue?vue&type=style&index=0&id=fdee9918&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdee9918",
  null
  
)

export default component.exports